/* BABY IN WOOD — page « Voir sur mon mur » (studio photo). Script commun mis en cache par le navigateur ; chaque instance s'initialise via window.biwStudioQ.push(id). */
(function(){
  "use strict";
  function init(SID){
  /* Analyse d'un visuel détouré : boîte opaque + orientation (moments d'inertie de la partie opaque).
     → {W,H : px naturels ; x,y,w,h : boîte en fractions 0..1 ; phi : angle de l'axe principal (° depuis l'horizontale,
        sens horaire à l'écran) ; elong : allongement (1 = rond, grand = fin et long)} ou null. */
  function biwDecorFit(im){
    try{
      if(!im||!im.naturalWidth||!im.naturalHeight) return null;
      var W=im.naturalWidth, H=im.naturalHeight, S=260, sc=Math.min(1,S/Math.max(W,H));
      var c=document.createElement('canvas'); c.width=Math.max(1,Math.round(W*sc)); c.height=Math.max(1,Math.round(H*sc));
      var cx=c.getContext('2d'); cx.drawImage(im,0,0,c.width,c.height);
      var d=cx.getImageData(0,0,c.width,c.height).data, w=c.width, h=c.height;
      var x0=w,y0=h,x1=-1,y1=-1,n=0,sx=0,sy=0,sxx=0,syy=0,sxy=0;
      for(var y=0;y<h;y++){ for(var x=0;x<w;x++){ var i=(y*w+x)*4; if(d[i+3]>16 && !(d[i]>245&&d[i+1]>245&&d[i+2]>245)){ if(x<x0)x0=x; if(x>x1)x1=x; if(y<y0)y0=y; if(y>y1)y1=y; n++; sx+=x; sy+=y; sxx+=x*x; syy+=y*y; sxy+=x*y; } } }
      if(x1<0||n<20) return null;
      var mx=sx/n, my=sy/n, uxx=sxx/n-mx*mx, uyy=syy/n-my*my, uxy=sxy/n-mx*my;
      var phi=0.5*Math.atan2(2*uxy, uxx-uyy)*180/Math.PI;
      var tr=(uxx+uyy)/2, dt=Math.sqrt(Math.max(0,((uxx-uyy)/2)*((uxx-uyy)/2)+uxy*uxy));
      return {W:W,H:H,x:x0/w,y:y0/h,w:(x1-x0+1)/w,h:(y1-y0+1)/h,phi:phi,elong:(tr+dt)/Math.max(1e-6,tr-dt)};
    }catch(e){ return null; }
  }
  /* Encombrement au mur d'un décor dont les cotes (Wcm × Hcm) sont données DROITES alors que le visuel peut être incliné
     (ex. la fusée photographiée en biais). → {bw, bh : largeur/hauteur réellement occupées (cm) ; deg : inclinaison}.
     Un visuel droit, ou pas assez allongé pour trancher, garde exactement les cotes déclarées. */
  function biwFootprint(Wcm, Hcm, fit){
    var r={bw:Wcm||0, bh:Hcm||0, deg:0};
    if(!fit||!(Wcm>0)||!(Hcm>0)) return r;
    var deg=fit.phi-((Hcm>=Wcm)?90:0); while(deg>90) deg-=180; while(deg<=-90) deg+=180;
    if(fit.elong<1.8||Math.abs(deg)<8) return r;
    /* un visuel DROIT a le même rapport largeur/hauteur que les cotes déclarées (le marchand mesure la boîte du décor) :
       on ne conclut à une inclinaison que si le rapport mesuré s'en écarte d'au moins 1,5× (fusée : 3,6×) */
    var rm=(fit.w*fit.W)/(fit.h*fit.H), qd=rm/(Wcm/Hcm);
    if(qd<1.5&&qd>0.6667) return r;
    var t=deg*Math.PI/180, c=Math.abs(Math.cos(t)), s=Math.abs(Math.sin(t));
    var bw=Wcm*c+Hcm*s, bh=Wcm*s+Hcm*c, rp=bw/bh;
    if(rp/rm>1.35||rm/rp>1.35) return r;
    return {bw:bw, bh:bh, deg:deg};
  }
  var root=document.getElementById('biwStudio-'+SID);
  if(!root||root.dataset.init) return;
  root.dataset.init='1';

  var DECORS=[], TXT={};
  try{ DECORS=JSON.parse(document.getElementById('biwStData-'+SID).textContent)||[]; }catch(e){ DECORS=[]; }
  try{ TXT=JSON.parse(document.getElementById('biwStTxt-'+SID).textContent)||{}; }catch(e){ TXT={}; }

  var KEY='biw_wall_v1', MAX_SIDE=1400, TTL=30*864e5;
  function track(name,data){
    try{ window.dataLayer=window.dataLayer||[]; window.dataLayer.push(Object.assign({event:'biw_sim_'+name, sim:'studio'},data||{})); }catch(e){}
    try{ document.dispatchEvent(new CustomEvent('biw:sim',{detail:{name:name,where:'studio',data:data||{}}})); }catch(e){}
  }

  var stage=document.getElementById('biwStStage-'+SID);
  var wall=stage.querySelector('.biw-st__wall');
  var decEls=[stage.querySelector('.biw-st__dec[data-slot="0"]'), stage.querySelector('.biw-st__dec[data-slot="1"]')];
  var cal=stage.querySelector('.biw-st__cal');
  var line=stage.querySelector('.biw-st__line');
  var ptA=stage.querySelector('[data-p="a"]');
  var ptB=stage.querySelector('[data-p="b"]');
  var len=stage.querySelector('.biw-st__len');
  var hint=stage.querySelector('.biw-st__hint');
  var loupe=stage.querySelector('.biw-st__loupe');
  var fileG=root.querySelector('input[data-role="gallery"]');
  var fileC=root.querySelector('input[data-role="camera"]');

  var panInfo=root.querySelector('[data-panel="info"]');
  var panCal=root.querySelector('[data-panel="calib"]');
  var nameEl=root.querySelector('.biw-st__selname');
  var dimsEl=root.querySelector('.biw-st__seldims');
  var priceEl=root.querySelector('.biw-st__selprice');
  var approxEl=root.querySelector('.biw-st__approx');
  var ctaEl=root.querySelector('.biw-st__cta');
  var addBtn=root.querySelector('[data-act="add"]');
  var DIRECT_ADD=root.getAttribute('data-direct-add')==='1';   /* réglage de la section : ajout direct (décors sans option) ou renvoi vers la fiche pour tous */
  var dec2Btn=root.querySelector('[data-act="dec2"]');
  var dec2Del=root.querySelector('[data-act="dec2del"]');
  var shareBtn=root.querySelector('[data-act="share"]');
  var duoEl=root.querySelector('.biw-st__duo');
  var slotsEl=root.querySelector('.biw-st__slots');
  var slotBtns=root.querySelectorAll('.biw-st__slot');
  var memoEl=root.querySelector('.biw-st__memo');
  var recalBtn=root.querySelector('[data-act="recal"]');
  var photoBtn=root.querySelector('.biw-st__ghost[data-role="photo"]');
  var compareEl=root.querySelector('.biw-st__compare');
  var cmIn=root.querySelector('.biw-st__cm input');
  var picker=document.getElementById('biwStPicker-'+SID);

  /* ---------- état : 2 emplacements de décor sur le même mur ---------- */
  var slots=[
    {el:decEls[0], i:-1, H:85, W:0, bh:85, fill:1, himg:0, on:false, approx:false, x:50, y:50, rot:0},
    {el:decEls[1], i:-1, H:85, W:0, bh:85, fill:1, himg:0, on:false, approx:false, x:74, y:52, rot:0}
  ];
  var active=0, hasSecond=false;
  var imgPxPerCm=0;       /* échelle issue du calibrage : px natifs d'image par cm réel */

  /* ---------- mémorisation locale (photo réduite + échelle), 30 jours ---------- */
  function loadSaved(){
    try{ var j=JSON.parse(localStorage.getItem(KEY)||'null'); if(!j||!j.img||!(j.ppc>0)) return null;
      if(Date.now()-(j.ts||0)>TTL){ localStorage.removeItem(KEY); return null; } return j; }catch(e){ return null; }
  }
  function saveWall(){
    try{ if(!wall.src||wall.src.indexOf('data:')!==0||!(imgPxPerCm>0)) return;
      localStorage.setItem(KEY, JSON.stringify({img:wall.src, ppc:imgPxPerCm, ts:Date.now()})); if(memoEl) memoEl.hidden=false; }catch(e){}
  }
  function forgetWall(){
    try{ localStorage.removeItem(KEY); }catch(e){}
    imgPxPerCm=0; wall.removeAttribute('src'); loupe.style.backgroundImage='';
    stage.classList.remove('has','placed','real','calib'); stage.classList.add('preview');
    stage.style.height=''; stage.style.minHeight='';
    if(memoEl) memoEl.hidden=true; if(compareEl) compareEl.hidden=true; recalBtn.hidden=true;
    if(photoBtn) photoBtn.textContent=TXT.btn_photo||photoBtn.textContent;
    showInfo(); track('forget');
  }
  function downscale(dataUrl, cb){
    var im=new Image();
    im.onload=function(){
      var w=im.naturalWidth,h=im.naturalHeight,s=Math.min(1,MAX_SIDE/Math.max(w,h));
      if(s>=1 && dataUrl.length<2.5e6){ cb(dataUrl); return; }
      try{ var c=document.createElement('canvas'); c.width=Math.round(w*s); c.height=Math.round(h*s);
        c.getContext('2d').drawImage(im,0,0,c.width,c.height); cb(c.toDataURL('image/jpeg',.85)); }catch(e){ cb(dataUrl); }
    };
    im.onerror=function(){ cb(dataUrl); };
    im.src=dataUrl;
  }

  /* ---------- mesure de la boîte opaque du décor (PNG détouré à marge) ---------- */
  function measureDec(s){
    var b=biwDecorFit(s.el); if(!b||b.h<0.2){ s.fill=1; s.bh=s.H; return; }
    s.fill=b.h; s.bh=biwFootprint(s.W,s.H,b).bh;
    if(imgPxPerCm>0) s.himg=s.bh*imgPxPerCm;
    if(stage.classList.contains('placed')) applyDecScale(s);
  }
  function containScale(){
    var iw=wall.naturalWidth, ih=wall.naturalHeight; if(!iw||!ih) return 0;
    var r=stage.getBoundingClientRect();
    return Math.min(r.width/iw, r.height/ih);
  }
  function fitStage(){
    var iw=wall.naturalWidth, ih=wall.naturalHeight; if(!iw||!ih) return;
    var r=stage.getBoundingClientRect();
    var maxH=Math.min(window.innerHeight*0.66, 680);
    var h=Math.min(maxH, Math.max(260, r.width*ih/iw));
    stage.style.minHeight='0'; stage.style.height=h+'px';
  }
  function applyDecScale(s){
    var cs=containScale(); if(!s.himg||!cs) return;
    s.el.style.height=Math.max(24, s.himg*cs/s.fill)+'px'; s.el.style.width='auto';
  }
  function applyAll(){ slots.forEach(function(s){ if(s.on) applyDecScale(s); }); }
  function placeSlot(s){ s.el.style.left=s.x+'%'; s.el.style.top=s.y+'%'; s.el.style.transform='translate(-50%,-50%) rotate('+(s.rot||0)+'deg)'; s.el.hidden=false; s.el.classList.toggle('is-active', slots[active]===s); }
  var rotIn=root.querySelector('[data-act="rot"]'), rot0=root.querySelector('[data-act="rot0"]');
  if(rotIn) rotIn.addEventListener('input',function(){ var s=slots[active]; s.rot=parseFloat(rotIn.value)||0; placeSlot(s); });
  if(rot0) rot0.addEventListener('click',function(){ var s=slots[active]; s.rot=0; if(rotIn) rotIn.value=0; placeSlot(s); track('rotate_reset'); });
  if(rotIn) rotIn.addEventListener('change',function(){ track('rotate',{deg:slots[active].rot}); });

  /* ---------- panneau : nom, prix, boutons selon l'emplacement actif ---------- */
  function refreshPanel(){
    var s=slots[active], d=(s.i>=0)?DECORS[s.i]:null; if(!d) return;
    nameEl.textContent=d.t; dimsEl.textContent=d.d||'';
    if(priceEl) priceEl.textContent=d.p||'';
    ctaEl.setAttribute('href', d.u);
    if(approxEl) approxEl.hidden=!s.approx;
    picker.querySelectorAll('.biw-st__thumb').forEach(function(b){ b.classList.toggle('on', parseInt(b.dataset.i,10)===s.i); });
    slotBtns.forEach(function(b,k){
      var sk=slots[k], dk=(sk.i>=0)?DECORS[sk.i]:null;
      b.hidden=!(k===0||hasSecond); b.classList.toggle('on', k===active);
      b.querySelector('span').textContent=dk?dk.t:'—';
    });
    if(slotsEl) slotsEl.hidden=!hasSecond;
    if(dec2Btn) dec2Btn.hidden=hasSecond||DECORS.length<2;
    if(dec2Del) dec2Del.hidden=!hasSecond;
    if(duoEl) duoEl.hidden=!hasSecond;
    /* ajout direct : uniquement les décors sans option à choisir (sinon la fiche gère les options) */
    if(addBtn){
      var d0=DECORS[slots[0].i], d1=hasSecond?DECORS[slots[1].i]:null;
      var direct = DIRECT_ADD && d0 && d0.o===0 && d0.a && (!hasSecond || (d1 && d1.o===0 && d1.a));
      addBtn.hidden=!direct;
      addBtn.textContent = hasSecond ? (TXT.add2||'Ajouter les 2 au panier') : (TXT.add||'Ajouter au panier');
      ctaEl.classList.toggle('biw-st__cta--gh', !!direct);
    }
    if(shareBtn) shareBtn.hidden=!stage.classList.contains('placed');
    if(rotIn) rotIn.value=s.rot||0;
  }

  /* ---------- sélection d'un décor → emplacement actif ---------- */
  function setDecor(s, i){
    if(i<0||i>=DECORS.length) return;
    s.i=i; var d=DECORS[i];
    s.H=(parseFloat(d.h)>0)?parseFloat(d.h):85; s.approx=!(parseFloat(d.h)>0); s.W=parseFloat(d.w)||0; s.bh=s.H;
    s.el.onload=function(){ measureDec(s); if(stage.classList.contains('placed')) applyDecScale(s); };
    if(s.el.getAttribute('src')!==d.s){ s.fill=1; s.el.setAttribute('src', d.s); }
    else if(s.el.complete && s.el.naturalWidth){ measureDec(s); }
    s.el.alt=d.t; s.on=true;
    if(imgPxPerCm>0 && stage.classList.contains('has')){ s.himg=(s.bh||s.H)*imgPxPerCm; stage.classList.add('placed','real'); placeSlot(s); applyDecScale(s); }
    else { placeSlot(s); }
  }
  function selectDecor(i){ setDecor(slots[active], i); refreshPanel(); track('decor',{slot:active,title:(DECORS[i]||{}).t}); }
  picker.querySelectorAll('.biw-st__thumb').forEach(function(b){ b.addEventListener('click',function(){ selectDecor(parseInt(b.dataset.i,10)); }); });
  slotBtns.forEach(function(b,k){ b.addEventListener('click',function(){ if(k===1&&!hasSecond) return; active=k; slots.forEach(function(s){ s.el.classList.toggle('is-active', s===slots[active]); }); refreshPanel(); }); });

  if(dec2Btn) dec2Btn.addEventListener('click',function(){
    if(DECORS.length<2) return;
    hasSecond=true; active=1;
    var next=(slots[0].i+1)%DECORS.length;
    slots[1].x=74; slots[1].y=52;
    setDecor(slots[1], next); refreshPanel(); track('second_decor');
  });
  if(dec2Del) dec2Del.addEventListener('click',function(){
    hasSecond=false; slots[1].on=false; slots[1].el.hidden=true; active=0;
    slots[0].el.classList.add('is-active'); refreshPanel();
  });

  /* ---------- bascule des panneaux ---------- */
  function showInfo(){ panInfo.hidden=false; panCal.hidden=true; }
  function showCalib(){ panInfo.hidden=true; panCal.hidden=false; }
  function toCalib(){
    stage.classList.add('calib'); stage.classList.remove('placed','real','preview');
    showCalib(); hint.textContent=TXT.hint_calib||'Faites glisser les 2 points le long de l’objet'; drawLine();
  }
  function toResult(){
    stage.classList.remove('calib'); stage.classList.add('placed','real');
    showInfo(); recalBtn.hidden=false;
    if(photoBtn) photoBtn.textContent=TXT.btn_change||'Changer de photo';
    if(compareEl) compareEl.hidden=false;
    hint.textContent=''; refreshPanel();
  }

  /* ---------- 1. photo (galerie OU appareil) : réduite avant usage ---------- */
  function useWall(dataUrl, then){
    wall.onload=function(){
      stage.classList.add('has'); stage.classList.remove('preview');
      fitStage(); loupe.style.backgroundImage="url('"+dataUrl+"')";
      then();
    };
    wall.src=dataUrl;
  }
  function loadWall(input){
    var f=input.files&&input.files[0]; input.value='';
    if(!f) return;
    var r=new FileReader();
    r.onload=function(e){ downscale(e.target.result, function(small){ useWall(small, function(){ A={x:26,y:16}; B={x:26,y:84}; imgPxPerCm=0; toCalib(); track('photo'); }); }); };
    r.readAsDataURL(f);
  }
  fileG.addEventListener('change',function(){ loadWall(fileG); });
  fileC.addEventListener('change',function(){ loadWall(fileC); });
  root.querySelectorAll('[data-act="pick"]').forEach(function(b){ b.addEventListener('click',function(e){ e.stopPropagation(); fileG.click(); }); });
  root.querySelectorAll('[data-act="camera"]').forEach(function(b){ b.addEventListener('click',function(e){ e.stopPropagation(); fileC.click(); }); });
  if(!(window.matchMedia && window.matchMedia('(pointer:coarse)').matches)){
    root.querySelectorAll('[data-act="camera"]').forEach(function(b){ b.style.display='none'; });
  }
  root.querySelectorAll('[data-act="forget"]').forEach(function(b){ b.addEventListener('click', forgetWall); });

  /* ---------- 2. calage ---------- */
  var A={x:26,y:16}, B={x:26,y:84};
  function drawLine(){
    ptA.style.left=A.x+'%'; ptA.style.top=A.y+'%';
    ptB.style.left=B.x+'%'; ptB.style.top=B.y+'%';
    var r=stage.getBoundingClientRect();
    var ax=A.x/100*r.width, ay=A.y/100*r.height, bx=B.x/100*r.width, by=B.y/100*r.height;
    var dx=bx-ax, dy=by-ay, L=Math.hypot(dx,dy);
    line.style.left=ax+'px'; line.style.top=ay+'px'; line.style.width=L+'px';
    line.style.transform='rotate('+(Math.atan2(dy,dx)*180/Math.PI)+'deg)';
    len.style.left=((A.x+B.x)/2)+'%'; len.style.top=((A.y+B.y)/2)+'%';
    len.textContent=(cmIn.value||'?')+' cm';
    return L;
  }
  var LP=(window.innerWidth<=600)?116:140, ZOOM=1.5;
  loupe.style.width=LP+'px'; loupe.style.height=LP+'px';
  function showLoupe(pt){
    var iw=wall.naturalWidth, ih=wall.naturalHeight; if(!iw||!ih) return;
    var r=stage.getBoundingClientRect();
    var px=pt.x/100*r.width, py=pt.y/100*r.height;
    var scale=Math.min(r.width/iw, r.height/ih);
    var rw=iw*scale, rh=ih*scale, ox=(r.width-rw)/2, oy=(r.height-rh)/2;
    var ix=px-ox, iy=py-oy;
    loupe.style.backgroundSize=(rw*ZOOM)+'px '+(rh*ZOOM)+'px';
    loupe.style.backgroundPosition=(-(ix*ZOOM-LP/2))+'px '+(-(iy*ZOOM-LP/2))+'px';
    var lx=Math.max(6,Math.min(r.width-LP-6,px-LP/2));
    var ly=py-LP-20; if(ly<6){ ly=py+20; }
    loupe.style.left=lx+'px'; loupe.style.top=ly+'px';
    loupe.classList.add('on');
  }
  function hideLoupe(){ loupe.classList.remove('on'); }
  var grabbed=null;
  cal.addEventListener('pointerdown',function(e){
    var r=stage.getBoundingClientRect();
    var x=(e.clientX-r.left)/r.width*100, y=(e.clientY-r.top)/r.height*100;
    grabbed=(Math.hypot(A.x-x,A.y-y)<=Math.hypot(B.x-x,B.y-y))?A:B;
    cal.setPointerCapture(e.pointerId); showLoupe(grabbed); e.preventDefault();
  });
  cal.addEventListener('pointermove',function(e){
    if(!grabbed) return;
    var r=stage.getBoundingClientRect();
    grabbed.x=Math.max(1,Math.min(99,(e.clientX-r.left)/r.width*100));
    grabbed.y=Math.max(1,Math.min(99,(e.clientY-r.top)/r.height*100));
    drawLine(); showLoupe(grabbed);
  });
  ['pointerup','pointercancel'].forEach(function(ev){ cal.addEventListener(ev,function(){ grabbed=null; hideLoupe(); }); });

  root.querySelectorAll('.biw-st__refs button').forEach(function(b){
    b.addEventListener('click',function(){
      root.querySelectorAll('.biw-st__refs button').forEach(function(x){x.classList.remove('on');});
      b.classList.add('on');
      if(b.dataset.custom){ cmIn.focus(); cmIn.select(); } else { cmIn.value=b.dataset.cm; }
      drawLine();
    });
  });
  cmIn.addEventListener('input',drawLine);

  root.querySelector('[data-act="valid"]').addEventListener('click',function(){
    var L=drawLine(), cm=parseFloat(cmIn.value);
    if(!L||L<20||!cm||cm<=0){ alert(TXT.err_points||'Écartez un peu plus les 2 points, et vérifiez la taille indiquée.'); return; }
    var cs=containScale();
    if(!cs){ alert(TXT.err_wait||'Un instant, la photo finit de charger…'); return; }
    imgPxPerCm=(L/cs)/cm;
    slots.forEach(function(s){ if(s.on){ s.himg=(s.bh||s.H)*imgPxPerCm; placeSlot(s); } });
    toResult(); applyAll(); saveWall(); track('calibrated',{cm:cm});
  });
  recalBtn.addEventListener('click',toCalib);

  /* ---------- 2b. rotation à deux doigts (tactile) : l'angle entre les deux doigts fait tourner le décor actif ---------- */
  var pts={}, multi=false, rotLock=false, angBase=0, rotBase=0;
  function ptAngle(){ var k=Object.keys(pts); if(k.length<2) return null; var a=pts[k[0]], b=pts[k[1]]; return Math.atan2(b.y-a.y,b.x-a.x)*180/Math.PI; }
  stage.addEventListener('pointerdown',function(e){
    if(e.pointerType!=='touch'||!stage.classList.contains('placed')) return;
    pts[e.pointerId]={x:e.clientX,y:e.clientY};
    if(Object.keys(pts).length===2){ multi=true; rotLock=true; angBase=ptAngle(); rotBase=slots[active].rot||0; slots.forEach(function(z){ z.el.classList.remove('grab'); }); }
  });
  stage.addEventListener('pointermove',function(e){
    if(!(e.pointerId in pts)) return; pts[e.pointerId]={x:e.clientX,y:e.clientY};
    if(!multi) return; var a=ptAngle(); if(a===null) return;
    var d=a-angBase; if(d>180) d-=360; if(d<-180) d+=360;
    var s=slots[active]; s.rot=Math.max(-90,Math.min(90,Math.round(rotBase+d))); if(rotIn) rotIn.value=s.rot; placeSlot(s); e.preventDefault();
  });
  function ptEnd(e){ if(!(e.pointerId in pts)) return; delete pts[e.pointerId]; var n=Object.keys(pts).length; if(multi && n<2){ multi=false; track('rotate',{deg:slots[active].rot,via:'touch'}); } if(n===0) rotLock=false; }
  ['pointerup','pointercancel'].forEach(function(ev){ stage.addEventListener(ev,ptEnd); });

  /* ---------- 3. déplacement des décors ---------- */
  slots.forEach(function(s,k){
    var drag=false, ox=0, oy=0, el=s.el;
    el.addEventListener('pointerdown',function(e){
      if(!stage.classList.contains('placed')) return;
      active=k; slots.forEach(function(z){ z.el.classList.toggle('is-active', z===s); }); refreshPanel();
      drag=true; el.classList.add('grab'); el.setPointerCapture(e.pointerId);
      var r=el.getBoundingClientRect();
      ox=e.clientX-(r.left+r.width/2); oy=e.clientY-(r.top+r.height/2); e.preventDefault();
    });
    el.addEventListener('pointermove',function(e){
      if(!drag||rotLock) return;
      var st=stage.getBoundingClientRect();
      s.x=Math.max(2,Math.min(98,((e.clientX-ox)-st.left)/st.width*100));
      s.y=Math.max(2,Math.min(98,((e.clientY-oy)-st.top)/st.height*100));
      el.style.left=s.x+'%'; el.style.top=s.y+'%';
    });
    ['pointerup','pointercancel'].forEach(function(ev){ el.addEventListener(ev,function(){ drag=false; el.classList.remove('grab'); }); });
  });

  /* ---------- 4. partager / enregistrer l'aperçu (mur + décors, composé dans le navigateur) ---------- */
  function exportComposite(cb){
    var iw=wall.naturalWidth, ih=wall.naturalHeight; if(!iw||!ih){ cb(null); return; }
    try{
      var c=document.createElement('canvas'); c.width=iw; c.height=ih; var cx=c.getContext('2d');
      cx.drawImage(wall,0,0,iw,ih);
      var r=stage.getBoundingClientRect(), cs=containScale(), ox=(r.width-iw*cs)/2, oy=(r.height-ih*cs)/2;
      slots.forEach(function(s){
        if(!s.on||s.el.hidden||!s.el.naturalWidth) return;
        var er=s.el.getBoundingClientRect();
        var cxp=(er.left+er.width/2-r.left-ox)/cs, cyp=(er.top+er.height/2-r.top-oy)/cs, w=s.el.offsetWidth/cs, h=s.el.offsetHeight/cs;
        cx.save(); cx.translate(cxp,cyp); cx.rotate((s.rot||0)*Math.PI/180); cx.drawImage(s.el, -w/2, -h/2, w, h); cx.restore();
      });
      c.toBlob(function(b){ cb(b); }, 'image/jpeg', .9);
    }catch(e){ cb(null); }
  }
  function shareBlob(b){
    var f; try{ f=new File([b],'baby-in-wood-mon-mur.jpg',{type:'image/jpeg'}); }catch(e){ f=null; }
    if(f && navigator.canShare && navigator.canShare({files:[f]})){ navigator.share({files:[f], title:'Baby in Wood', text:TXT.share_text||'Le décor sur notre mur'}).catch(function(){}); return; }
    var a=document.createElement('a'); a.href=URL.createObjectURL(b); a.download='baby-in-wood-mon-mur.jpg'; document.body.appendChild(a); a.click();
    setTimeout(function(){ URL.revokeObjectURL(a.href); a.remove(); }, 2000);
  }
  if(shareBtn) shareBtn.addEventListener('click',function(){
    if(!stage.classList.contains('placed')) return;
    shareBtn.disabled=true;
    exportComposite(function(b){ shareBtn.disabled=false; if(!b){ alert(TXT.err_share||'Le partage n’est pas disponible sur ce navigateur.'); return; } shareBlob(b); track('share',{decors:hasSecond?2:1}); });
  });

  /* ---------- 5. ajout direct au panier (décors sans option) ---------- */
  if(addBtn) addBtn.addEventListener('click',function(){
    var items=[]; slots.forEach(function(s){ if(s.on && s.i>=0){ var d=DECORS[s.i]; if(d&&d.v&&d.o===0) items.push({id:d.v, quantity:1}); } });
    if(!items.length) return;
    var old=addBtn.textContent; addBtn.disabled=true; addBtn.textContent='…';
    fetch('/cart/add.js',{method:'POST',headers:{'Content-Type':'application/json','Accept':'application/json'},body:JSON.stringify({items:items})})
      .then(function(r){ if(!r.ok) throw 0; return r.json(); })
      .then(function(){
        addBtn.textContent=TXT.added||'Ajouté ✓'; track('add_to_cart',{n:items.length});
        try{ document.documentElement.dispatchEvent(new CustomEvent('cart:refresh',{bubbles:true})); }catch(e){}
        setTimeout(function(){ var t=document.querySelector('[aria-controls="mini-cart"]'); if(t){ t.click(); } else { location.href='/cart'; } addBtn.disabled=false; addBtn.textContent=old; }, 700);
      })
      .catch(function(){ addBtn.disabled=false; addBtn.textContent=old; location.href='/cart'; });
  });
  ctaEl.addEventListener('click',function(){ track('cta',{title:(DECORS[slots[active].i]||{}).t}); });

  window.addEventListener('resize',function(){
    if(stage.classList.contains('has')) fitStage();
    if(stage.classList.contains('calib')) drawLine();
    if(stage.classList.contains('placed')) applyAll();
  });

  /* ---------- init : décor par défaut, puis mur mémorisé (ou ?decor=handle) ---------- */
  var start=0;
  try{ var q=new URLSearchParams(location.search).get('decor'); if(q){ DECORS.some(function(d,k){ if((d.u||'').split('/').pop()===q){ start=k; return true; } return false; }); } }catch(e){}
  if(DECORS.length){ setDecor(slots[0], start); refreshPanel(); }
  var saved=loadSaved();
  if(saved && DECORS.length){
    useWall(saved.img, function(){
      imgPxPerCm=saved.ppc;
      slots.forEach(function(s){ if(s.on){ s.himg=(s.bh||s.H)*imgPxPerCm; placeSlot(s); } });
      toResult(); applyAll(); if(memoEl) memoEl.hidden=false; track('restored');
    });
  }
  }
  var q = window.biwStudioQ || [];
  window.biwStudioQ = { push: function(u){ init(u); } };
  for (var i = 0; i < q.length; i++) init(q[i]);
})();
